
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    isDetail: {
      default: false,
      type: Boolean
    },
    isNotAllProduct: {
      default: false,
      type: Boolean
    }
  }
})
export default class OtopackWarning extends Vue {
  props: any = this.$props;
  get warning() {
    if (this.props.isNotAllProduct) {
      return this.$t('shipmentRates.errorOttopackNotAllProduct');
    } else {
      return this.$t('shipmentRates.errorOttopackAllProduct');
    }
  }
}
